import { Container, Typography, Box, List, ListItem, ListItemText } from "@mui/material";
import { Helmet } from "react-helmet";

export default function FreeAiChatbot() {
  const base =
    (typeof window !== "undefined" && window.location && window.location.origin) ||
    "https://talk-mate-backend.web.app";
  const enUrl = `${base}/en/free-ai-chatbot`;
  const frUrl = `${base}/fr/chatbot-ia-gratuit`;

  return (
    <Container sx={{ py: 6 }}>
      <Helmet>
        <title>Free AI chatbot for websites – Talkmate</title>
        <meta
          name="description"
          content="Create an AI agent for your site, add your context, and deploy via embed code or shareable link with Talkmate."
        />
        <meta property="og:title" content="Free AI chatbot for websites – Talkmate" />
        <meta
          property="og:description"
          content="Build AI agents that answer visitors, capture leads, and hand off to a human when needed."
        />
        <meta name="robots" content="index, follow" />
        <link rel="alternate" href={enUrl} hrefLang="en" />
        <link rel="alternate" href={frUrl} hrefLang="fr" />
        <link rel="canonical" href={enUrl} />
      </Helmet>

      <Typography variant="h3" fontWeight={800} gutterBottom>
        Free AI chatbot for your website
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Talkmate lets you create an AI agent, add your business context, and deploy it in minutes via an embed code or a
        shareable link.
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          What you can do
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Add your site/product/FAQ context for precise answers." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Deploy with a widget, public link, or iframe—no heavy code." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Switch to manual mode: the operator replies while the bot pauses." />
          </ListItem>
        </List>
      </Box>

      <Box>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Why Talkmate?
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="AI agent set up in minutes, multilingual, with customizable context." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Free plan to test: create one agent, share it, and see responses." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Widget and shareable link ready to capture conversations and leads." />
          </ListItem>
        </List>
      </Box>
    </Container>
  );
}
